<template>
    <el-dialog title="保存提示词模板" :visible.sync="dialogVisibleTips" :append-to-body="true" width="650px"
        :before-close="handleClose" class="dialog_diy">
        <div style="height: 100%;padding:15px">
            <div class="t_box">
                <span>模板名称：</span>
                <input type="text" class="binfo_input" v-model="title">
            </div>
            <div class="t_box">
                <span>模板描述：</span>
                <textarea rows="3" class="binfo_input binfo_textarea" cols placeholder="请输入内容"
                    v-model="detail"></textarea>
            </div>
            <div class="t_box">
                <span>权限：</span>
                <el-radio-group v-model="radio">
                    <el-radio :label="0">个人</el-radio>
                    <el-radio :label="1">组织内</el-radio>
                    <el-radio :label="2">所有人</el-radio>
                </el-radio-group>
            </div>
            <div class="t_box">
                <span>是否公开提示词：</span>
                <el-radio-group v-model="isT">
                    <el-radio :label="1">不公开</el-radio>
                    <el-radio :label="2">公开</el-radio>
                </el-radio-group>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="selectT(2)" type="primary">确定并保存课程</el-button>
            <el-button @click="selectT" type="primary">确 定</el-button>
            <el-button @click="close">关 闭</el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    props: {
        dialogVisibleTips: {
            type: Boolean,
            default: false
        },
        tipsJson: {
            type: Object,
            default: () => { }
        },
        aiJson: {
            type: Object,
            default: () => { }
        },
        userid: {
            type: String,
            default: ''
        },
        templateid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            title: "",
            detail: "",
            radio: 0,
            isT: 1
        }
    },
    watch: {
        dialogVisibleTips(newValue, oldValue) {
            if (newValue) {
                this.title = this.tipsJson.name ? this.tipsJson.name : ''
                this.detail = this.tipsJson.detail ? this.tipsJson.detail : ''
                this.radio = this.tipsJson.open ? parseInt(this.tipsJson.open) : 0
                this.isT = this.tipsJson.istips ? parseInt(this.tipsJson.istips) : 0
            } else {
                this.$emit('update:tipsJson', {
                    name: this.title,
                    detail: this.detail,
                    open: this.radio,
                    istips: this.istips
                })
            }
        },
    },
    methods: {
        handleClose(done) {
            this.close()
            done();
        },
        close() {
            this.$emit('update:dialogVisibleTips', false)
        },
        selectT(type) {
            if (!this.title) {
                this.$message.error('请输入模板名称');
                return
            }
            if (this.templateid) {
                this.$confirm(
                    "确定修改此模板嘛？",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.updateTipsTemplate(type);
                    })
                    .catch(() => {
                        return;
                    });
            }else{
                this.addTipsTemplate(type);
            }
            // let params = {
            //     userid: this.userid,
            //     name: this.title
            // }
            // this.ajax
            //     .get(this.$store.state.api + "selectTipsTemplateB", params)
            //     .then((res) => {
            //         if (res.data[0].length) {
            //             this.$confirm(
            //                 "发现已有此模板，是否以现在的内容覆盖此模板？",
            //                 "提示",
            //                 {
            //                     confirmButtonText: "确定",
            //                     cancelButtonText: "取消",
            //                     type: "warning",
            //                 }
            //             )
            //                 .then(() => {
            //                     this.addTipsTemplate();
            //                 })
            //                 .catch(() => {
            //                     return;
            //                 });
            //         } else {
            //             this.addTipsTemplate();
            //         }
            //     })
            //     .catch((err) => {
            //         this.$message.error("网络不佳");
            //         console.error(err);
            //     });
        },
        addTipsTemplate(type) {
            let params = [{
                n: this.title,
                d: this.detail,
                json: JSON.stringify(this.aiJson),
                o: this.radio,
                uid: this.userid,
                isT: this.isT,
                stand: 'cn'
            }]
            this.ajax
                .post(this.$store.state.api + "addTipsTemplate2E", params)
                .then((res) => {
                    this.$message.success("保存成功");
                    console.log(res.data);
                    this.$emit('update:templateid', res.data[0][0].id)
                    console.log(this.templateid)
                    if(type == 2){
                        this.$emit('addWork', type)
                    }else{
                        this.$emit('retrunCourse')
                    }
                    this.close();
                })
                .catch((err) => {
                    this.$message.error("网络不佳");
                    console.error(err);
                });
        },
        updateTipsTemplate(type) {
            let params = [{
                n: this.title,
                d: this.detail,
                json: JSON.stringify(this.aiJson),
                o: this.radio,
                uid: this.templateid,
                isT: this.isT,
                stand: 'cn'
            }]
            this.ajax
                .post(this.$store.state.api + "addTipsTemplate2E", params)
                .then((res) => {
                    this.$message.success("修改成功");
                    if(type == 2){
                        this.$emit('addWork', type)
                    }else{
                        this.$emit('retrunCourse')
                    }
                    this.close();
                })
                .catch((err) => {
                    this.$message.error("网络不佳");
                    console.error(err);
                });
        }
    },
}
</script>

<style scoped>
.dialog_diy>>>.el-dialog {
    height: auto;
    margin: 15vh auto 0 !important;
}

.dialog_diy>>>.el-dialog__header {
    background: #454545 !important;
    padding: 15px 20px;
}

.dialog_diy>>>.el-dialog__body {
    height: calc(100% - 124px);
    box-sizing: border-box;
    padding: 0px;
}


.dialog_diy>>>.el-dialog__title {
    color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn {
    top: 19px;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}

.dialog_diy>>>.el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}


.dialog_diy>>>.el-dialog__body,
.dialog_diy>>>.el-dialog__footer {
    background: #fafafa;
}



.binfo_input {
    width: 100%;
    margin: 0;
    padding: 5px 7px;
    display: block;
    min-width: 0;
    outline: none;
    box-sizing: border-box;
    background: none;
    border: none;
    border-radius: 4px;
    background: #fff;
    font-size: 15px;
    resize: none;
    font-family: "Microsoft YaHei";
    min-height: 48px;
    /* border: 1px solid #3682fc00; */
    border: 1.5px solid #cad1dc;
}

.binfo_textarea {
    border: 1.5px solid #cad1dc;
    font-size: 15px;
    resize: none;
    /* background: #f6f6f6; */
    font-family: "Microsoft YaHei";
}

.binfo_input:focus-visible {
    border: 1.5px solid #3681fc !important;
}


.t_box {
    display: flex;
    margin-bottom: 15px;
}

.t_box>span:nth-child(1) {
    min-width: 135px;
    font-size: 16px;
    color: #000;
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/aiEasy/tipsDialog.vue